import { Box, Paper, Typography, alpha } from "@mui/material"
import { TrendingUp, TrendingDown } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"

const StatCard = ({ title, value, icon, color, trend, trendLabel, linkTo }) => {
  const isPositive = trend >= 0
  const navigate = useNavigate()

  const handleCardClick = () => {
    if (linkTo) {
      navigate(linkTo)
    }
  }

  return (
    <Paper
      elevation={2}
      onClick={handleCardClick}
      sx={{
        p: 3,
        borderRadius: 2,
        height: "100%",
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
        transition: "transform 0.2s, box-shadow 0.2s",
        cursor: linkTo ? "pointer" : "default",
        "&:hover": linkTo ? {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 25px 0 rgba(0,0,0,0.1)",
        } : {},
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "4px",
          height: "100%",
          backgroundColor: color,
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            {title}
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            {value}
          </Typography>

          {trend !== undefined && (
            <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: isPositive ? "success.main" : "error.main",
                  mr: 1,
                }}
              >
                {isPositive ? <TrendingUp fontSize="small" /> : <TrendingDown fontSize="small" />}
                <Typography variant="body2" sx={{ ml: 0.5, fontWeight: 500 }}>
                  {isPositive ? "+" : ""}
                  {trend}%
                </Typography>
              </Box>
              {trendLabel && (
                <Typography variant="caption" color="textSecondary">
                  {trendLabel}
                </Typography>
              )}
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 48,
            height: 48,
            borderRadius: "50%",
            backgroundColor: alpha(color, 0.1),
            color: color,
          }}
        >
          {icon}
        </Box>
      </Box>
    </Paper>
  )
}

export default StatCard

